import { serviceLoading } from 'common/loaderReducer';
import Loader from 'components/Loader';
import * as React from 'react';
import * as _ from 'lodash';
import { InLine, CheckContainer } from './styles';
import { Title, BodyTextCenter, BodyTextLeft,DescriptionContainer, BottomTextContainer, ButtonContainer } from '../Upsell/styles';
import { ModalUpsell }  from '../Upsell';
import { KEYS } from 'common/constants';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
import ActionBar from 'components/ActionBar';
import { getUrlSetupAPI } from './state/actions';
import upsellsetup from './upsellsetup.svg';
import { GET_URLSETUP_API_REQUEST } from './state/actionTypes';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { RootState } from 'store/types';
import { connect } from 'react-redux';

export interface ModalUpsellSetupProps {
    shouldShow: boolean;
    dealerId?: string;
    url?: string;
    UrlSetupAPI?: (dealerId?: string) => {};
    isRequesting?: boolean;
}

export interface ModalUpsellSetupStates {
}

class ModalUpsellSetup extends React.Component<ModalUpsellSetupProps, ModalUpsellSetupStates> {
    constructor(props) {
        super(props);
    }

    componentWillMount(){
        if (this.props.UrlSetupAPI) this.props.UrlSetupAPI(this.props.dealerId);
    }

    onSetupClick = () => {
        window.location.href=this.props.url??'';
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ENTER) {
            this.onSetupClick()
        }
    }

    render() {
        return (
            <ModalUpsell shouldShow={this.props.shouldShow}>
                <Title>
                    Listings Manager Advanced
                </Title>
                <DescriptionContainer>
                    <BodyTextCenter>
                        Manage your local listings from one place
                    </BodyTextCenter>
                </DescriptionContainer>
                <img src={upsellsetup}/>
                <BottomTextContainer>
                <br/>
                        <BodyTextCenter>
                            Listings Manager isn't synced to your listings. If you've recently
                            signed up, your account set up is in progress and you will soon see
                            your listings dashboard!
                            <br/>
                            <br/>
                            Feel free to contact support if you have any questions.
                        </BodyTextCenter>
                        <br/>
                </BottomTextContainer>
                <ButtonContainer>
                {
                    this.props.isRequesting &&
                    <Loader margin={"10px auto"}/>
                }
                {
                    !this.props.isRequesting &&
                    <TCButton
                        type={TC_BUTTON_TYPE.PRIMARY}
                        onClick={this.onSetupClick}
                    >
                        Contact Support
                    </TCButton>
                }
                </ButtonContainer>
            </ModalUpsell>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    dealerId: state.dealers.dealer.selectedDealer?.id,
    url: state.dealers.urlSetup.url,
    isRequesting: serviceLoading(state, [GET_URLSETUP_API_REQUEST])
});

const mapDispatchToProps = (dispatch) => ({
    UrlSetupAPI: (dealerId: string) => dispatch(getUrlSetupAPI(dealerId))
});

export default delayUnmounting<ModalUpsellSetupProps>(connect(mapStateToProps,mapDispatchToProps)(ModalUpsellSetup));
